// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React from 'react'
import pickBy from 'lodash/pickBy'
import { STORAGE_KEY } from '../constants'
import {
  DAYS,
  EVENT_TYPES,
  EVENT_TYPES_VALUES,
  EVENT_TYPES_VALUES_LOGS,
  MONTHNAME,
  MONTH_NAMES,
} from '../constants/globalConstants'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import getConfigDetails  from '../services/config'
import Resizer from 'react-image-file-resizer'
import { toast } from 'react-toastify'
import { JSEncrypt } from 'jsencrypt'
// const moment = require('moment');


let userAgent = navigator.userAgent || navigator.vendor
export const iOS = (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  ? true : false

//   Sat Apr 01 2023 17:05:00 GMT+0530 (India Standard Time)
export const formatDate = (date) => {
  let date_final
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = MONTH_NAMES[newDate.getMonth()] + ' ' + newDate.getDate()
  } else {
    let format_date = new Date(date)
    date_final =
      MONTH_NAMES[format_date.getMonth()] + ' ' + format_date.getDate()
  }
  return date_final
}

export const formatDateDays = (date) => {
  let date_final
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = DAYS[newDate.getDay()]
  } else {
    let format_date = new Date(date)
    date_final = DAYS[format_date.getDay()]
  }
  return date_final
}

export const formatAMPM = (date) => {
  let strTime
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    let hours = newDate.getHours()
    let minutes = newDate.getMinutes()
    let ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes ? (minutes < 10 ? '0' + minutes : minutes) : '00'
    strTime = hours + ':' + minutes + ' ' + ampm
  } else {
    let hours = new Date(date).getHours()
    let minutes = new Date(date).getMinutes()
    let ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes ? (minutes < 10 ? '0' + minutes : minutes) : '00'
    strTime = hours + ':' + minutes + ' ' + ampm
  }
  return strTime
}

export const dateFormatter = (date, format) => moment(date).format(format)
// export const dateFormatterMonth = (date, format) => moment(date).format(format)

export function formatMonthYear(date) {
  let date_final
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final =
      MONTHNAME[newDate.getMonth()] + ' ' + newDate.getFullYear()
  } else {
    let format_date = new Date(date)
    date_final =
      MONTHNAME[format_date.getMonth()] + ' ' + format_date.getFullYear()
  }

  return date_final
}



export const getEventType = (event) => {
  switch (event) {
    case EVENT_TYPES.EVENT:
      return EVENT_TYPES_VALUES.EVENT
    case EVENT_TYPES.BUNDLE_PASS:
      return EVENT_TYPES_VALUES.BUNDLE_PASS
    case EVENT_TYPES.PARTY_PASS:
      return EVENT_TYPES_VALUES.PARTY_PASS
    case EVENT_TYPES.SIMPLE:
      return EVENT_TYPES_VALUES.SIMPLE
    default:
      return EVENT_TYPES_VALUES.EVENT
  }
}
// export const getEventTypeById = (event_id, log) => {
//   switch (event_id) {
//     case `${getConfigDetails.FULL_SEASON}`:
//       return log ? EVENT_TYPES_VALUES_LOGS.BUNDLE_PASS : EVENT_TYPES_VALUES.BUNDLE_PASS
//     case `${getConfigDetails.HALF_SEASON}`:
//       return  log ? EVENT_TYPES_VALUES_LOGS.PARTY_PASS : EVENT_TYPES_VALUES.PARTY_PASS
//     case `${getConfigDetails.SIX_PACK}`:
//       return log ? EVENT_TYPES_VALUES_LOGS.SIMPLE : EVENT_TYPES_VALUES.SIMPLE
//     default:
//       return log ? EVENT_TYPES_VALUES_LOGS.EVENT : EVENT_TYPES_VALUES.EVENT
//   }
// }

export const getEventTypeByPassType = (pass_type, is_full_season, log) => {
  // switch (event_id) {
  if (pass_type == EVENT_TYPES?.BUNDLE_PASS && is_full_season == 1) {
    return log ? EVENT_TYPES_VALUES_LOGS.BUNDLE_PASS : EVENT_TYPES_VALUES.BUNDLE_PASS
  } else if (pass_type == EVENT_TYPES?.BUNDLE_PASS && is_full_season != 1) {
    return log ? EVENT_TYPES_VALUES_LOGS.PARTY_PASS : EVENT_TYPES_VALUES.PARTY_PASS
  } else if (pass_type == EVENT_TYPES?.PARTY_PASS) {
    return log ? EVENT_TYPES_VALUES_LOGS.SIMPLE : EVENT_TYPES_VALUES.SIMPLE
  } else {
    return log ? EVENT_TYPES_VALUES_LOGS.EVENT : EVENT_TYPES_VALUES.EVENT
  }
}

export const getEventCount = (eventId) => {
  // const halfSeasonEvents = localStorage.getItem('userChooseEvents')
  const eventDetails = JSON.parse(localStorage.getItem(EVENT_TYPES?.EVENT))

  switch (eventId) {
    case getConfigDetails.HALF_SEASON:
      return eventDetails?.all_event?.length / 2
    case getConfigDetails.FULL_SEASON:
      return eventDetails?.all_event?.length
    case getConfigDetails.SIX_PACK:
      return 6
    default:
      return 1
  }
}

export const getSanitizedValues = (values) =>
  pickBy(values, (value) => {
    const expression = !(
      value === 0 ||
      value === '' ||
      value === undefined ||
      value === null ||
      Number.isNaN(value) ||
      value?.length === 0
    )
    return expression
  })

const setLocalStorage = (userData) => {
  userData.map((data) => {
    localStorage.setItem(data.key, data.value)
  })
}

export const getLoginDetailFromSession = () =>
  localStorage.getItem(STORAGE_KEY.ACCESS_TOKEN)

export const getBearerToken = () => localStorage.getItem(STORAGE_KEY.ID_TOKEN)

export const setLoginDetailInSession = (loggedInUserData) => {
  const userData = [
    {
      key: STORAGE_KEY.ACCESS_TOKEN,
      value: loggedInUserData?.AccessToken,
    },
    {
      key: STORAGE_KEY.REFRESH_TOKEN,
      value: loggedInUserData?.RefreshToken,
    },
    {
      key: STORAGE_KEY.ID_TOKEN,
      value: loggedInUserData?.IdToken,
    },
    {
      key: STORAGE_KEY.TOKEN_TYPE,
      value: loggedInUserData?.TokenType,
    },
  ]
  setLocalStorage(userData)
}

export function isLoggedIn() {
  return !!localStorage.getItem('accessToken')
}

export function isUserLoggedIn() {
  const userDataFromStorage = localStorage.getItem('userData') ? localStorage.getItem('userData') : '{}'
  const userData = JSON.parse(userDataFromStorage)
  const access_token = userData?.access_token
  if (access_token && access_token != '') {
    return true
  } else {
    return false
  }
}

export function isArrayWithLength(arr) {
  return Array.isArray(arr) && arr.length
}

export function getAllowedRoutes(routes) {
  const role = localStorage.getItem('userRole')
  return routes.filter(({ permission }) => {
    if (!permission) return true
    else if (!isArrayWithLength(permission)) return true
    else return permission.indexOf(role) !== -1
  })
}

export function classes() {
  return [...arguments].join(' ')
}

export const clearSessionDetails = () => {
  Object.keys(localStorage)?.filter((item) => (item !== 'eventData' && item !== 'event_data' && item !== 'sessionDetails' && item !== 'personal_info' && item !== 'userData' && item !== 'partnerData' && item !== 'urlHistory' && item !== 'isLoggedIn' && item !== 'selectEventType' && item !== 'selectedFacilityId' && item !== 'client_id' && item !== 'selectEventLinkFacility') ? localStorage.removeItem(item) : '')
}

export const restrictInputValues = (event) => {
  if (!`${event.target.value}${event.key}`.match(/^[0-9]{0,6}$/)) {
    // block the input if result does not match
    event.preventDefault()
    event.stopPropagation()
    return false
  }
}

export const getEventLogName = (pass_type, is_full_season) => `MAPCO - BOOK NOW - ${getEventTypeByPassType(pass_type, is_full_season, 'log')}`


export const validateEmail = (email) => {
  // eslint-disable-next-line no-useless-escape
  const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
  return pattern.test(email)
}

export const fileChangedHandler = (event, fileId, setUpdateFileState, fileWidth, fileHeight) => {
  let fileInput = false
  let file = document.getElementById(fileId).files[0]
  fileInput = file && (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif')
  if (fileInput) {
    try {
      Resizer.imageFileResizer(
        file,
        fileWidth,
        fileHeight,
        'PNG', // fileType(JPEG, PNG,WEBP)
        100,  // quality compression(for jpeg)
        0, // rotation(0-100)
        (uri) => {
          new Promise((resolve, reject) => {
            const img = new Image()
            // the following handler will fire after a successful loading of the image
            img.onload = () => {
              const { naturalWidth: width, naturalHeight: height } = img
              resolve({ width, height })
              setUpdateFileState({ [fileId]: uri })
            }
            // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
            img.onerror = () => {
              reject('There was some problem with the image.')
            }
            img.src = URL.createObjectURL(uri)
          })
        },
        'file' // outputType( base64, blob or file)
      )
    } catch (err) {
      setUpdateFileState({ fileId: '' })
    }
  } else {
    setUpdateFileState({ fileId: '' })
  }
}

export const encryptionHandler = (d) => {
  var nonceString = d.name_on_card + ':' + d.card_number + ':' + d.expiration_date + ':' + d.security_code + ':' + d.zip_code
  var CryptoJSAesJson = {
    stringify: function (cipherParams) {
      var j = {
        ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
        iv: '',
        s: ''
      }
      if (cipherParams.iv)
        j.iv = cipherParams.iv.toString()
      if (cipherParams.salt)
        j.s = cipherParams.salt.toString()
      return JSON.stringify(j)
    },
    parse: function (jsonStr) {
      var j = JSON.parse(jsonStr)
      var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
      if (j.iv)
        cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s)
        cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams
    }
  }
  var encrypted = CryptoJS.AES.encrypt(JSON.stringify(nonceString), getConfigDetails?.chiperKey, { format: CryptoJSAesJson }).toString()
  return encrypted
}

// export const getPartnerDetails = () => {
//   const partner = (localStorage.getItem('partnerData') && (localStorage.getItem('partnerData') !== undefined || localStorage.getItem('partnerData') !== 'undefined')) ? JSON.parse(localStorage.getItem('partnerData')) : (sessionStorage.getItem('partnerData') && (sessionStorage.getItem('partnerData') !== undefined || sessionStorage.getItem('partnerData') != 'undefined')) ? JSON.parse(sessionStorage.getItem('partnerData')) : {}
//   return partner
// }
export const getPartnerDetails = () => {
  const partnerData = localStorage.getItem('partnerData') || sessionStorage.getItem('partnerData')

  // Check if partnerData is not undefined or 'undefined' and is valid JSON
  if (partnerData && partnerData !== 'undefined') {
    try {
      return JSON.parse(partnerData)
    } catch (error) {
      console.error('Error parsing partner data:', error)
      return {} // Return empty object if parsing fails
    }
  }

  return {} // Return empty object if partner data is not found or invalid
}



export function sortPortalPermissionByKey(permissionObj, sectionName) {
  return permissionObj?.[sectionName]?.map((item) => item)
}

export const isPermissionExist = (data, itemName) => {
  const filterObj = (data?.length > 0) && data?.filter((item) => item?.display_name == itemName)
  if (filterObj[0]?.is_default == '1') {
    return true
  } else {
    return false
  }
}

export const getName = (data) => {
  return `${(data?.first_name) ? data?.first_name : ''} ${(data?.last_name) ? data?.last_name : ''}`
}

export function loggedInUserData() {
  const userData = JSON.parse(localStorage.getItem('userData') ? localStorage.getItem('userData') : '{}')
  return userData
}

export const convertParkingTime = (startTime, endTime) => {
  // const facilityTimeZone = localStorage.getItem('facilitiesTimezone')
  // Parse the input times into moment objects
  const startMoment = moment(startTime)
  const endMoment = moment(endTime)

  // Check if the end time is on the next day
  if (endMoment.isBefore(startMoment)) {
    // If the end time is on the next day, add 1 day to the end time
    endMoment.add(1, 'day')
  }

  // Format the moments into the desired 12-hour clock format
  const formattedStartTime = moment(startMoment, 'h:mm A')
  const formattedEndTime = moment(endMoment, 'h:mm A')
  // Combine the formatted times into the final string
  // const formattedTimeRange = `${formattedStartTime} - ${formattedEndTime}`
  const formattedTimeRange = { startDate: moment(formattedStartTime).format('h:mm A'), endDate: moment(formattedEndTime).format('h:mm A') }

  return formattedTimeRange
}

// export const convertFacilityTimeZone = (time) => {
//   const facilityTimeZone = localStorage.getItem('facilitiesTimezone')
//   const startMoment = moment(new Date(time)).tz(`${facilityTimeZone}`).format('MM-DD-YYYY hh:mm A')
//   return startMoment
// }


export const isNetworkAvailable = () => {
  let result = false
  if (window.navigator.onLine) {
    result = true
  }
  else {
    result = false
  }
  return result
}

export const getErrorMessage = (response) => {
  let errorMsg = 'Sorry! something went wrong, please try again.'
  const errorsList = response.errors
  if (errorsList.message !== 'Validation Errors') {
    errorMsg = errorsList.message
  } else {
    for (const key in errorsList.detail) {
      if (Object.prototype.hasOwnProperty.call(errorsList.detail, key)) {
        if (typeof errorsList.detail === 'undefined') {
          errorMsg = errorsList.message
        } else {
          errorMsg = Array.isArray(errorsList.detail[key]) ? errorsList.detail[key][0] : errorsList.detail[key]
        }
      }
    }
  }

  return errorMsg
}


// export const postionOfElement = (id) => {
//   const offsets = document.getElementById(id).getBoundingClientRect()
//   return offsets
// }

export const getDeviceType = () => {
  // Find if the device is IOS or Android/General
  let userAgent = navigator.userAgent || navigator.vendor
  const deviceType = (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    ? true : false
  return deviceType
}

export const getConvertedDate = (date) => {
  const deviceType = getDeviceType()
  let newDate = date
  if (date && date !== '' && deviceType) {
    let arr = date?.split(/[- :]/)
    newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
  } else {
    newDate = date
  }
  return newDate
}

const getActiveDaysOfMonth = (end_time, start_time, date, month, year) => {
  // moment('2014-03-24T01:15:00.000Z').isAfter(moment('2014-03-24T01:14:00.000Z'))
  // moment('2014-03-24T01:15:00.000Z').isBefore(moment('2014-03-24T01:14:00.000Z'));
  if (
    (
      (moment(end_time, 'YYYY-MM-DD HH:mm:ss').isAfter(moment().month(month).date(date).year(year))) &&
      (
        (moment(start_time, 'YYYY-MM-DD HH:mm:ss').isBefore(moment().month(month).date(date).year(year))) ||
        (moment(start_time, 'YYYY-MM-DD HH:mm:ss').isSame(moment().month(month).date(date).year(year), 'day'))
      )
    ) ||
    (moment(end_time, 'YYYY-MM-DD HH:mm:ss').isSame(moment().month(month).date(date).year(year), 'day'))
  ) {
    return true
  } else {
    return false
  }
}

export const getActiveDatesCalendar = (daysInMonth, allEventsData, curMonth, curYear, tab = '1') => {
  const monthDaysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1)
  const monthDaysArr = monthDaysArray.map((item) => {
    if (allEventsData?.length > 0) {
      let disab = true
      allEventsData?.map((event) => {
        if (getActiveDaysOfMonth(tab == '1' ? event.end_time : event?.end_date + ' ' + event?.exit_time_begin, tab == '1' ? event.start_time : event?.start_date + ' ' + event?.entry_time_begin, item, curMonth, curYear)) {
          disab = false
        }
      })
      return { date: item, isDisabled: disab }
    } else {
      return { date: item, isDisabled: true }
    }
  })
  return monthDaysArr
}



export const validExpiryDate = (value) => {
  let expiryDateCheck = value.length == 4 && value.substring(0, 2) < 13 && (value.substring(0, 2) >= moment(new Date()).format('MM') && value.substring(2) >= moment(new Date()).format('YY')
    || value.substring(0, 2) <= moment(new Date()).format('MM') && value.substring(2) > moment(new Date()).format('YY')
  )
  return expiryDateCheck
}

export const restrictSpecialChar = (e) => {
  const result = (e.key == '!' || e.key == '@' || e.key == '#' || e.key == '$' || e.key == '%' || e.key == '^'
    || e.key == '&' || e.key == '~' || e.key == '`' || e.key == '*' || e.key == '(' || e.key == ')' || e.key == '_'
    || e.key == '=' || e.key == '+' || e.key == '[' || e.key == ']' || e.key == '{' || e.key == '}' || e.keyCode == 220
    || e.key == '|' || e.key == ':' || e.key == ';' || e.keyCode == 222 || e.key == ' ' || e.key == '?' || e.key == '.' || e.key == ',' || e.key == '>' || e.key == '<')
  if (result) {
    e.preventDefault()
  } else {
    return result
  }
}

export const emailRegEx = /^[A-Z0-9._%+-]+@[A-Z0-9-]+(?!.*?[.]{2})[A-Z0-9.-]+\.[A-Z]{2,}$/i

export const getdaysByString = (params) => {
  const data = {
    found: false,
    value: []
  }
  if (params?.monday == '1') {
    data.found = true
    data.value.push('Monday')
  }
  if (params?.tuesday == '1') {
    data.found = true
    data.value.push('Tuesday')
  }
  if (params?.wednesday == '1') {
    data.found = true
    data.value.push('Wednesday')
  }
  if (params?.thursday == '1') {
    data.found = true
    data.value.push('Thursday')
  }
  if (params?.friday == '1') {
    data.found = true
    data.value.push('Friday')
  }
  if (params?.saturday == '1') {
    data.found = true
    data.value.push('Saturday')
  }
  if (params?.sunday == '1') {
    data.found = true
    data.value.push('Sunday')
  }
  return data
}

export const restrictInValidCharPassword = (value = '') => {
  // List of restricted characters
  // const restrictedChars = /[()\\`~:;"/<>]/g
  const restrictedChars = /[^!@#$%^&*?\w\s-]/g

  // Remove restricted characters from the input value
  let filteredValue = value?.replace(restrictedChars, '')
  filteredValue = filteredValue?.replace('_', '')
  return filteredValue
}

// export const restrictInValidCharLicense = (value = '') => {
//   const restrictedChars = /[^!@#$%^&*?+\w\s-]/g

//   // Remove restricted characters from the input value
//   let filteredValue = value?.replace(restrictedChars, '')
//   filteredValue = filteredValue?.replace('_', '')
//   return filteredValue
// }

export const restrictInValidCharLicense = (value = '') => value.replace(/[^a-zA-Z0-9]/g, '')

export const postionOfElement = (id) => {
  const offsets = document.getElementById(id).getBoundingClientRect()
  return offsets
}

export const getPortalUrl = () => {
  if (window.location.host.includes('localhost')) {
    return getConfigDetails?.customerLocalUrl
  } else if (window.location.hostname.includes('breezeparking')) {
    return getConfigDetails?.portalURL
  } else if (window?.location?.toString()?.includes('rev-pass')) {
    return getConfigDetails?.revcustomerPortalURL
  } else {
    return getConfigDetails?.portalURL
  }
}

export const getAdminUrl = () => {
  if (window.location.host.includes('localhost')) {
    return getConfigDetails?.adminLocalUrl
  } else if (window?.location?.toString()?.includes('rev-pass')) {
    return getConfigDetails?.revadminUrl
  } else {
    return getConfigDetails?.adminUrl
  }
}

export const notify = (type, message, heading = '') => {
  let messagePass = <div><h4>{heading}</h4><p>{message}</p></div>
  toast.dismiss()
  if (type === 'error') {
    toast.error(messagePass, {
      position: toast.POSITION.TOP_RIGHT
    })
  } else if (type === 'success') {
    toast.success(messagePass, {
      position: toast.POSITION.TOP_RIGHT
    })
  }
}

export const clearAllLoginLocalStorage = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem('isLoggedIn')
  localStorage.removeItem('masquerade')
  localStorage.removeItem('partnerSecret')
  localStorage.removeItem('partnerData')

  sessionStorage.removeItem('partnerSecret')
  sessionStorage.removeItem('partnerData')

  // If you REALLY want to clear everything:
  // localStorage.clear()
  // sessionStorage.clear()
}

export const formatYearMonthExpiry = (value) => {
  if (value === null || value === undefined) return ''

  let str = String(value).trim()

  // Keep only digits
  str = str.replace(/\D/g, '')

  // Handle 5-digit case (YYYYM)
  if (str.length === 5) {
    const year = str.slice(0, 4)
    const month = str.slice(4)
    return `${year}/0${month}`
  }

  // Handle 6-digit case (YYYYMM)
  if (str.length === 6) {
    const year = str.slice(0, 4)
    const month = str.slice(4)
    return `${year}/${month}`
  }

  return ''
}

const checkButtonToShow = (arr = []) => {
  let res = true
  if(arr.length == 0) {
    return false
  }
  arr.map((item) => {
    if(item == '' || item == null || item == undefined) {
      res = false
    }
  })
  return res
}

export const showhideWalletButton = (facility) => {
  const device = getDeviceType()
  let buttonToShow = false
  if(facility?.facility_payment_details) {
      const { facility_payment_type_id, heartland_applepay_identifier, heartland_merchant_name, heartland_merchant_id, heartland_gpay_merchant,
              wallet_datacap_mid, datacap_script_url, wallet_datacap_token, wallet_datacap_ios_merchant, wallet_datacap_gpay_merchant, fiserv_env, fiserv_apple_merchant_identifier
      } = facility?.facility_payment_details || {}
      
      if(facility_payment_type_id == 4) {
        const loopArr = device ? [heartland_applepay_identifier, heartland_merchant_name] : [heartland_merchant_name, heartland_merchant_id, heartland_gpay_merchant]
        buttonToShow = checkButtonToShow(loopArr)
      } else if(facility_payment_type_id == 2) {
        const loopArr = device ? [wallet_datacap_mid, datacap_script_url, wallet_datacap_token, wallet_datacap_ios_merchant] : [wallet_datacap_token, wallet_datacap_mid, wallet_datacap_gpay_merchant, datacap_script_url]
        buttonToShow = checkButtonToShow(loopArr)
      } else if(facility_payment_type_id == 3) {
        const loopArr = device ? [fiserv_apple_merchant_identifier] : [fiserv_env]
        buttonToShow = checkButtonToShow(loopArr)
      }
  }

  if (device && facility?.facility_configuration?.show_apple_pay_button == '1' && buttonToShow && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development')) {
    return true
  } else if (!device && facility?.facility_configuration?.show_google_pay_button == '1' && window.location.protocol === 'https:') {
    return true
  } else {
    return false
  }
}
export const getMobileOS = () => {
  const ua = navigator.userAgent
  if (/android/i.test(ua)) {
    return 'Android'
  }
  else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'iOS'
  }
  return 'Other'
}
export const getNearestMonth = (months = []) => {
  const now = moment()

  // Find nearest month-year
  const nearest = months.reduce((closest, dateStr) => {
    const date = moment(dateStr, 'MMM-YYYY')

    // Calculate absolute difference in months
    const diff = Math.abs(now.diff(date, 'months', true))
    const closestDiff = closest ? Math.abs(now.diff(moment(closest, 'MMM-YYYY'), 'months', true)) : Infinity

    return diff < closestDiff ? dateStr : closest
  }, null)

  return nearest
}

export const isTimeBeforeCurrentFacilityTime = (targetTime, timeZone = 'America/New_York') => {

  // Resolve timezone
  const facilityTimeZone = timeZone || 'America/New_York'

  // Current time based on facility timezone
  const currentTime = moment().tz(facilityTimeZone).format('YYYY-MM-DD HH:mm:ss')

  return moment(targetTime).isBefore(currentTime)
}

export const getPriceBreakdown = (sessionDetails) => {
    return <>
    {Number(sessionDetails?.data?.net_parking_amount) > 0 ?
      <div className="row align-items-center fw-bold text-primary">
        <div className="col text-start">Net Parking Amount</div>
        <div className="col text-end">{`$${getFormattedAmountNumber(sessionDetails?.data?.net_parking_amount)}`}</div>
      </div> : ''}
    {Number(sessionDetails?.data?.surcharge_fee) > 0 ?
      <div className="row align-items-center fw-bold text-primary">
        <div className="col text-start">Surcharge Fee</div>
        <div className="col text-end">{`$${getFormattedAmountNumber(sessionDetails?.data?.surcharge_fee)}`}</div>
      </div> : ''}
    {Number(sessionDetails?.data?.tax_rate) > 0 ?
      <div className="row align-items-center fw-bold text-primary">
        <div className="col text-start">Tax</div>
        <div className="col text-end">{`$${getFormattedAmountNumber(sessionDetails?.data?.tax_rate)}`}</div>
      </div> : ''}
    {((sessionDetails?.data?.processing_fee && Number(sessionDetails?.data?.processing_fee) > 0) || (sessionDetails?.data?.additional_fee && Number(sessionDetails?.data?.additional_fee) > 0) || (sessionDetails?.data?.cc_fee && Number(sessionDetails?.data?.cc_fee) > 0)) ?
      <div className="row align-items-center fw-bold text-primary">
        <div className="col text-start">Processing Fee</div>
        <div className="col text-end">{`$${sessionDetails?.data?.additional_fee ? getFormattedAmountNumber(Number(sessionDetails?.data?.processing_fee || '0') + Number(sessionDetails?.data?.additional_fee)) : sessionDetails?.data?.cc_fee ? getFormattedAmountNumber(Number(sessionDetails?.data?.processing_fee || '0') + Number(sessionDetails?.data?.cc_fee)) : getFormattedAmountNumber(sessionDetails?.data?.processing_fee || '0')}`}</div>
      </div> : ''}
    {sessionDetails?.data?.discounted_amount || sessionDetails?.data?.discounted_amount > 0 ? <div className="row mb-3 align-items-center fw-bold text-primary">
      <div className="col text-start">Discount Amount</div>
      <div className="col text-end">{`$${getFormattedAmountNumber(sessionDetails?.data?.discounted_amount)}`}</div>
    </div> : null}
  </>
}

export const getFormattedAmountNumber = (inputNumber) => {

  let digits = getPartnerDetails()?.decimal_precision || 2

    if (
        inputNumber === null ||
        inputNumber === undefined ||
        inputNumber === ''
    ) {
        return Number(0)?.toFixed(digits)
    }

    const number = Number(inputNumber?.toString()?.replace(/,/g, ''))

    if (isNaN(number)) {
        return Number(0)?.toFixed(digits)
    }

    return number?.toFixed(digits)

}

export const encodePasswordBase = (password) => {
 
    if(password === null || password === undefined || password === '') {
    return ''
    } 

    const encrypt = new JSEncrypt()
    let PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY || ''
    PUBLIC_KEY = PUBLIC_KEY.replace(/\\n/g, '\n')
    encrypt.setPublicKey(PUBLIC_KEY)
    const encrypted = encrypt.encrypt(password)

    return encrypted
}
